import * as React from 'react';
import Cookies from 'universal-cookie';
import { getOrgPrettyName } from 'src/api/utils';
import { getOrganisationDetails } from 'src/api/login';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setOrgDetails } from 'src/actions/organisationProfileActions';
import { fetchAuthSettings } from 'src/api/organisation-config.api';

declare let window: any;
const withAuth = (Component) => {
  class WithAuthClass extends React.PureComponent<any, any> {
    state = {
      isAuthenticated: false,
      isLoading: true,
      authSettings: null,
    };

    setStorage = (
      organisationId,
      userId,
      accessToken,
      type,
      chaId,
      ffId,
      shippingLineId,
      email,
      username,
      role,
      phone,
    ) => {
      const storage = window.localStorage;
      storage.setItem('organisationId', organisationId);
      storage.setItem('userId', userId);
      storage.setItem('authToken', accessToken);
      storage.setItem('type', type);
      storage.setItem('chaId', chaId);
      storage.setItem('ffId', ffId);
      storage.setItem('shippingLineId', shippingLineId);
      storage.setItem('email', email);
      storage.setItem('username', username);
      storage.setItem('role', role);
      storage.setItem('phone', phone);
      storage.setItem('lastActionTime', String(new Date()));
    };

    async componentDidMount() {
      try {
        const orgPrettyName = getOrgPrettyName();
        const storage = window.localStorage;

        // Step 1: Fetch org details first (needed for cookie-to-localStorage sync)
        const response = await getOrganisationDetails(orgPrettyName);
        const { organisationId: orgId = '', monitoringModules, isDevrevEnabled } = response?.data || {};
        sessionStorage.setItem('organisationId', orgId);
        this.props.setOrgDetails(response?.data);

        // Step 2: Sync cookies to localStorage before any auth-dependent API calls
        // On SSO/cookie-based login, auth data lives in cookies, not localStorage
        const cookies = new Cookies(window.document.cookie);
        const cookiesResponse = cookies.getAll();
        if (cookiesResponse && cookiesResponse.organisationId === orgId) {
          this.setStorage(
            cookiesResponse.organisationId,
            cookiesResponse.userId,
            cookiesResponse.accessToken,
            cookiesResponse.type,
            cookiesResponse.cha_id,
            cookiesResponse.ff_id,
            cookiesResponse.shipping_line_id,
            cookiesResponse.email,
            cookiesResponse.username,
            cookiesResponse.role,
            cookiesResponse.phone,
          );
          cookies.remove('organisationId');
          cookies.remove('userId');
          cookies.remove('accessToken');
          cookies.remove('type');
          cookies.remove('shipping_line_id');
          cookies.remove('email');
          cookies.remove('username');
          cookies.remove('role');
          cookies.remove('phone');
        }

        // Step 3: Now localStorage is populated — fetch auth settings
        const accessToken = storage.getItem('authToken');
        const organisationId = storage.getItem('organisationId');

        const authSettingsResponse = accessToken && organisationId
          ? await fetchAuthSettings()
          : null;

        storage.setItem('monitoringModules', JSON.stringify(monitoringModules || {}));
        storage.setItem('isDevrevEnabled', isDevrevEnabled);
        const tokenTmp = storage ? storage.getItem('organisationId') : false;
        this.setState({
          isLoading: false,
          isAuthenticated: !!tokenTmp,
          authSettings: authSettingsResponse?.data || null,
        });
      } finally {
        if (this.state.isLoading) {
          this.setState({ isLoading: false });
        }
      }
    }

    render() {
      const { isLoading, isAuthenticated, authSettings } = this.state;
      if (isLoading) {
        return null;
      }
      return (
        <Component
          {...this.props}
          authenticated={isAuthenticated}
          authSettings={authSettings}
        />
      );
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
      {
        setOrgDetails,
      },
      dispatch
    );
  };

  const connector = connect(null, mapDispatchToProps);

  return connector(WithAuthClass);
};

export default withAuth;
